import { EduContentTOCInterface } from './EduContentTOC.interface';
import { SectionContentInterface } from './SectionContent.interface';

export interface SectionInterface {
  id?: number;
  name?: string;
  showTeacher?: boolean;
  showStudent?: boolean;
  type?: SectionType;
  eduContentTOCId?: number;
  eduContentTOC?: EduContentTOCInterface;
  displayOrder?: number;
  config?: SectionConfigInterface;
  sectionContents?: SectionContentInterface[];
  // References EduContentTOCNavigation.externalId (= ink Navigation.id), not its local PK.
  navigationId?: number;
}

export interface SectionConfigInterface {
  index?: number;
  theme: string;
  imageUrl?: string;
  headerTitle?: string;
  footerIcon?: string;
}

export enum SectionType {
  DISPLAY = 'display',
  // DISPLAY_EXPAND = 'display-expandable',
  LIST = 'list',
  IMAGE_DICT = 'image-dict',
  GRID = 'grid',
}
